import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import { AccountFileReactionForNotification } from '../graphql';
import AccountFilesRedirect from '../../../routing/AccountFiles/AccountFilesRedirect';
import FullScreenLoader from '../../FullScreenLoader';
import HeadOpenGraphMeta from '../../HeadOpenGraphMeta';
import { getThumbBySize } from '../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';

const propTypes = {
  accountFileReaction: PropTypes.shape({
    id: PropTypes.string,
    parent: PropTypes.shape({
      id: PropTypes.string,
    }),
    video: PropTypes.shape({
      id: PropTypes.string,
    }),
    photo: PropTypes.shape({
      id: PropTypes.string,
      is_owner: PropTypes.string,
      is_uploader: PropTypes.string,
      albums: PropTypes.shape({
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
          }),
        ),
      }),
    }),
  }),
  loading: PropTypes.bool,
};

const AccountFileReactionRedirect = ({ loading, accountFileReaction }) => {
  if (loading) {
    return <FullScreenLoader />;
  }

  const username = accountFileReaction?.account?.username;

  return (
    <Fragment>
      {accountFileReaction && (
        <HeadOpenGraphMeta
          title={`Reaction by ${
            username ? `@${username}` : accountFileReaction?.account?.name
          }`}
          imageUrl={
            getThumbBySize(
              accountFileReaction?.photo?.thumbnail_urls,
              IMAGE_SIZE_CODE.MEDIUM2X,
            )?.url
          }
          videoUrl={accountFileReaction?.video?.embed_url}
        />
      )}

      <AccountFilesRedirect
        loading={loading}
        photo={accountFileReaction?.photo}
        video={accountFileReaction?.video}
        searchQuery={{
          reaction: accountFileReaction?.id,
        }}
      />
    </Fragment>
  );
};

AccountFileReactionRedirect.propTypes = propTypes;

const withAccountFileReactionForNotification = graphql(
  AccountFileReactionForNotification,
  {
    props: ({ data: { accountFileReaction, loading } = {}, ownProps }) => ({
      accountFileReaction,
      loading: ownProps.loading || loading,
    }),
    options: ({ match }) => ({
      variables: {
        id: match.params.accountFileReactionId,
      },
      fetchPolicy: 'cache-and-network',
    }),
    skip: ({ match }) => !match.params.accountFileReactionId,
  },
);

export default compose(
  withRouter,
  withAccountFileReactionForNotification,
)(AccountFileReactionRedirect);
